import { mkRoutes } from './_';
import { systemUrls } from './urls/system';
import SystemAnalytics from '../../screens/system/analytics';
import SystemCommunitiesIndex from '../../screens/system/communities';
import SystemCommunitiesManage from '../../screens/system/communities/manage';
import SystemPartners from '../../screens/system/partners';
import SystemUsersIndex from '../../screens/system/users/index';
import SystemUsersDetail from '../../screens/system/users/detail';
import SystemModeration from '../../screens/system/moderation';
import SystemSettings from '../../screens/system/settings';
import SystemExploreCategories from '../../screens/system/explore-categories';
import SystemPolicies from '../../screens/system/policies';
import SystemStaticContent from '../../screens/system/static-content';
import SystemStaticContentNavigation from '../../screens/system/static-content-nav';
import SystemAppPages from '../../screens/system/app-pages';
import SystemRootFiles from '../../screens/system/root-files';
import SystemAssets from '../../screens/system/assets';
import SystemNrhpSync from '../../screens/system/nrhp-sync';
import SystemActivityLog from '../../screens/system/activity-log';
import SystemErrorLog from '../../screens/system/error-log';
export const [systemRoutes, systemRoutesArray] = mkRoutes(systemUrls, {
    analytics: SystemAnalytics,
    communities: SystemCommunitiesIndex,
    communitiesManage: SystemCommunitiesManage,
    partners: SystemPartners,
    users: SystemUsersIndex,
    usersDetail: SystemUsersDetail,
    moderation: SystemModeration,
    settings: SystemSettings,
    exploreCategories: SystemExploreCategories,
    nrhpSync: SystemNrhpSync,
    policies: SystemPolicies,
    staticContent: SystemStaticContent,
    staticContentNav: SystemStaticContentNavigation,
    appPages: SystemAppPages,
    rootFiles: SystemRootFiles,
    assets: SystemAssets,
    activityLog: SystemActivityLog,
    errorLog: SystemErrorLog,
});
